// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"394734c3","706":"9d45423b"}[chunkId] + ".chunk.js";
};